/* src/app/footer/footer.component.scss */
/*# sourceMappingURL=footer.component.css.map */
